import {
  createStandardAction,
  ActionType,
  createReducer,
} from 'typesafe-actions';

/**
 * 편집 상태 히스토리 리덕스
 */

type THistoryState = {
  // past: NodeListOf<ChildNode>[];
  past: any;
  present: any;
  // present: NodeListOf<ChildNode>[];
  future: any;
  // future: NodeListOf<ChildNode>[];
  type: string;
};

export const SET = 'history/SET';
const UNDO = 'history/UNDO';
const REDO = 'history/REDO';

export const setAction = createStandardAction(SET)<Node>();
export const undoAction = createStandardAction(UNDO)();
export const redoAction = createStandardAction(REDO)();

type actions = {
  setAction: typeof setAction;
  undoAction: typeof undoAction;
  redoAction: typeof redoAction;
};

type HistoryAction = ActionType<actions>;

const initialState: THistoryState = {
  past: [],
  present: null,
  future: [],
  type: '',
};

const MAX_HISTORY_LEN = 20;

const history = createReducer<THistoryState, HistoryAction>(initialState, {
  [SET]: (state, action) => {
    const {past, present} = state;
    if (past.length === MAX_HISTORY_LEN) {
      past.shift();
    }
    return {
      past: [...past, present],
      present: action.payload,
      future: [],
      type: SET,
    };
  },
  [UNDO]: (state) => {
    const {past, present, future} = state;
    const previous = past[past.length - 1];
    const newPast = past.slice(0, past.length - 1);
    console.log('previous: ', previous);
    return {
      past: newPast,
      present: previous,
      future: [present, ...future],
      type: UNDO,
    };
  },
  [REDO]: (state) => {
    const {past, present, future} = state;
    const next = future[0];
    const newFuture = future.slice(1);

    return {
      past: [...past, present],
      present: next,
      future: newFuture,
      type: REDO,
    };
  },
});

export default history;
